// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__364XX","table":"News_table__24KiV","actions":"News_actions__37MN6"};